import View from '@/base/views/view';

class MailTemplateView extends View {

    static table = 'mailtemplate';

    static options () {
        let obj = {
            fieldsDataReplace: {
                MessageBody: { name: 'MessageBody', label: 'Message', editor: 'text-area-html-style',  columns: 12, hideFromList: true},
            },
            extraFields: [
                { name: 'tab1', label: 'Plain Text',  editor: 'tab', hideFromList: true,
                    fields: [
                        { name: 'MessageBody', editor: 'text-area',  columns: 12, hideFromList: true, rows: 20, defValue: ''},
                    ]
                },
                { name: 'tab2', label: 'Preview',  editor: 'tab', hideFromList: true,
                    fields: [
                        { name: 'MessageBody', editor: 'html',  columns: 12},
                    ]
                },
                { name: 'tab3', label: 'Styles',  editor: 'tab', hideFromList: true,
                    fields: [
                        { name: 'Styles', editor: 'text-area',  columns: 12, hideFromList: true, rows: 20},
                    ]
                },

            ],
            canAdd: true,
            canCopy: true,
            title: 'Mail Templates',
            actions: [
                {
                    label: 'Create Mail',
                    method: 'createMail',
                    id: 'createMail'
                }
            ],
        }
        return obj
    }

    static async getTableOptions () {
        let res = await super.getTableOptions(this.options());
        return res;
    }

}

export default MailTemplateView;
    